import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

export type sendFeedbackToClientsOptions = {
  listingId: string;
  appointmentId: string;
};

const sendFeedbackReminder = async (
  listingId: string,
  appointmentId: string,
) => {
  const config: AxiosRequestConfig = {
    url: `/listing/${listingId}/send_feedback_reminder/${appointmentId}`,
    method: 'post',
  };

  await axios.request(config);
};

export default sendFeedbackReminder;
